import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { actions } from "../../../../redux/modules/users";
import Title from "../../Utils/Headers/Title";
import LoadMask from "../../Utils/LoadMask/LoadMask";
import Form from "../Create/Form";
import { formValueSelector } from "redux-form";

const Container = (props) => {
    const [list, updateList] = useState([]);
    const [showInactive, setShowInactive] = useState(false);
    useEffect(() => {
        props.leer(props.match.params.id);
        return () => {
            props.setItem({});
        };
    }, []);

    const { loader, item, value_is_pilot } = props;

    useEffect(() => {
        updateList(props.item.approved_courses);
    }, [item]);

    return (
        <div className="card pb-3 mb-5">
            <div
                className={`px-4 pt-4 container-title-create${
                    showInactive ? "-requesting_support" : ""
                }`}
            >
                <Title
                    textWhite={true}
                    title={"Usuarios"}
                    subtitle={"Detalles generales de usuario"}
                />
            </div>
            <div className="p-0 px-3 pt-3">
                <div className="p-0 px-3 pt-3">
                    {item.id && (
                        <Form
                            item={item}
                            validateUserCreated={props.validateUserCreated}
                            valueIsPilot={value_is_pilot}
                            me={props.me}
                            loading={loader}
                            isView={true}
                            list={list}
                            updateList={updateList}
                            showInactive={showInactive}
                            setShowInactive={setShowInactive}
                            url={props.match.url}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

//  Decorador para leer los valores del form
const selector = formValueSelector("userForm");

const mstp = (state) => {
    const value_is_pilot = selector(state, "is_pilot");
    return {
        value_is_pilot: value_is_pilot,
        me: state.login.me,
        ...state.users,
    };
};

const mdtp = { ...actions };

export default connect(mstp, mdtp)(Container);
